import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<Text sx={{
      fontSize: [4, 5, 6],
      fontWeight: `bold`,
      color: `heading`,
      textAlign: `center`
    }} mdxType="Text">
  Hi!
</Text>
<Text sx={{
      fontSize: [1, 2, 3],
      textAlign: `center`
    }} mdxType="Text">
  Software engineer most of the time.
</Text>
<Text sx={{
      fontSize: [1, 2, 3],
      textAlign: `center`
    }} mdxType="Text">
  Beer aficionado, 60% of the time, all the time.
</Text>
<Text sx={{
      fontSize: [1, 2, 3],
      textAlign: `center`
    }} mdxType="Text">
  And this is my blog some of the time.
</Text>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      